import React, { useState } from 'react';
import { Button, Input } from '../..';
const KeyInput = (props) => {
    const [token, setToken] = useState('');
    // TODO: Lang
    return (React.createElement("div", null,
        React.createElement("form", { onSubmit: (e) => {
                e.preventDefault();
                e.stopPropagation();
                props.onSubmit(token);
            } },
            React.createElement("p", null, "Du vil modtage en kode per mail, som du skal indtaste her for at nulstille din kode."),
            React.createElement(Input, { placeholder: "Kode", onChange: (e) => {
                    setToken(e.target.value);
                }, value: token }),
            React.createElement(Button, { block: true, style: { marginBottom: '10px' } }, "Godkend"),
            React.createElement(Button, { block: true, onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    props.onCancel();
                }, theme: "secondary" }, "Annuller"))));
};
export default KeyInput;
//# sourceMappingURL=TokenInput.js.map